export default {"src":"/_next/static/media/cryptocontrol_small_logo.d0a3de54.svg","height":31,"width":55,"blurWidth":0,"blurHeight":0};